import { FC } from "react";

import { IErrorComponent } from "../ErrorComponent";
import { ErrorTemplate } from "../blocks/ErrorTemplate";
import { AccessForbiddenIcon } from "../../../icons/errors";

export const AccessForbiddenError: FC<IErrorComponent> = (props) => {
  const message = "У вас недостаточно прав для просмотра этой информации.";

  return (
    <ErrorTemplate
      {...props}
      icon={AccessForbiddenIcon}
      header="Доступ запрещен"
      message={message}
      showReloadButton={false}
    />
  );
};
